import { useSearchParams } from 'react-router-dom';
import { useGetWriteoffApprovalsByUserQuery } from '../../../../../../services/WriteoffService';
import { useAppSelector } from '../../../../../../app/hooks';
import { useGetMyProfileQuery } from '../../../../../../services/ProfileService';

export interface UseMyApprovalsDataReturn {
  approvalsItems: any[];
  isLoading: boolean;
  error: any;
  refetch: () => void;
  company: string;
  center: string;
  userName: string;
}

/**
 * Hook for fetching the current user's approval items.
 */
export function useMyApprovalsData(): UseMyApprovalsDataReturn {
  const selectedCenter = useAppSelector(state => state.center.selectedCenter);
  const { data: profile } = useGetMyProfileQuery();
  const company = profile?.organization || '';
  const userName = profile?.name || '';

  const {
    data: approvalsItems = [],
    isLoading,
    error,
    refetch,
  } = useGetWriteoffApprovalsByUserQuery(
    {
      center: selectedCenter || '',
      company,
      userName,
    },
    {
      skip: !selectedCenter || !company || !userName,
    }
  );

  return {
    approvalsItems,
    isLoading,
    error,
    refetch,
    company,
    center: selectedCenter || '',
    userName,
  };
}
